import React, { useMemo } from 'react';
import { sortPickListItems } from '../../utils/sortMethods';
import { generatePickListSummaryFromDockets } from '../../../common/utils/pickList/generatePickListSummary';


import PickListSummaryItem from './PickListSummaryItem';

const PickListSummaryList = ({
	showAllSelections,
	serviceRun,
	sortMethod,
	hideImages,
	onClickQuantity,
	canPick,
	showExpiryWarnings,
	expiryWarningsConfig,
	onOpenExpiryWarningsDialog,
}) => {
	const sortedItems = useMemo(() => {
		const listOfDockets = serviceRun.serviceDockets
			.filter(serviceDocket => serviceDocket.pickList);

		const summarisedItems = generatePickListSummaryFromDockets(
			listOfDockets,
			sortMethod.includes('machinePosition'),
			showAllSelections,
			expiryWarningsConfig,
		);

		return sortPickListItems(sortMethod, summarisedItems);
	}, [serviceRun.serviceDockets, sortMethod, showAllSelections, expiryWarningsConfig]);

	return (
		<>
			{
				sortedItems.map(item => {
					return (
						<PickListSummaryItem
							onClickQuantity={onClickQuantity}
							key={item.productId}
							item={item}
							hideImages={hideImages}
							canPick={canPick}
							showAllSelections={showAllSelections}
							serviceRunId={serviceRun.id}
							showExpiryWarnings={showExpiryWarnings}
							onOpenExpiryWarningsDialog={onOpenExpiryWarningsDialog}
						/>
					);
				})
			}
		</>
	);
};

export default PickListSummaryList;
